import * as React from 'react';

import Popover from 'components/popover/Popover';

import { __t, applyTranslations } from 'utils/language';

import './discovery-creators-filter-popover.scss';

applyTranslations(require('modules/freemium/components/freemium-popover/freemium-popover.i18n.json'));
applyTranslations(require('./discovery-creators-filter-popover.i18n.json'));

type Props = {
  triggerComponent: React.ReactNode
};

const MSG_KEY = 'discovery_creators_filter_popover';

const DiscoveryCreatorsFilterPopover = ({
  triggerComponent
}: Props): JSX.Element => (
  <Popover
    classNamePopover="discovery-creators-filter-popover"
    classNameWrapper="discovery-creators-filter-popover__wrapper"
    classNameTrigger="discovery-creators-filter-popover__trigger"
    triggerComponent={triggerComponent}
  >
    <div className="discovery-creators-filter-popover">
      <div className="discovery-creators-filter-popover__message">
        {__t(`${MSG_KEY}.message`)}
      </div>
      <a
        href={__t('freemium_popover.email')}
        className="discovery-creators-filter-popover__link"
      >
        {__t(`${MSG_KEY}.contact`)}
      </a>
    </div>
  </Popover>
);

export default DiscoveryCreatorsFilterPopover;
